import { StringOrNothing, getObject, getText, postObject, putObject, getJson, postVoidResult, IStatusResponse, putVoid, putVoidResult } from "../ChoiceApi";

export async function search(payload: UpdoxReminderHistoryInputs): Promise<UpdoxReminderHistoryResponse|undefined> {
    return await postObject("api/Updox/GetReminderHistory", payload);
} 

export interface UpdoxReminderHistoryInputs
{
    startTime: string,
    endTime: string
}

export interface UpdoxReminderHistoryItem
{
    accountId?: string, 
    appointmentId: string, 
    patientId: string, 
    updoxReminderId: number, 
    updoxReminderHistoryId: number, 
    type: string, 
    createdAt: string, 
    sentAt: string, 
    repliedAt: string, 
    reminderStatus: string, 
    reminderStatusReason: string,
    filteringAppointmentId?: string,
    filteringAppointmentStatus?: string
}

export interface UpdoxReminderHistoryResponse
{
    successful: boolean, 
    responseMessage: string, 
    responseCode: number, 
    lines: UpdoxReminderHistoryItem[]
}